<template>
  <div>
    <template v-if="template === 'edit' || typeof template === 'undefined'">
      <label :class="labelClass ? labelClass : 'u-label'">
        {{ field.label + (field.required ? '* ' : '') }}
      </label>
      <input
        v-if   = "!field.readonly"
        :class = "'qa-' +field.name + '__input'"
        :value = "value"
        @input = "update($event.target)"
        ref    = "input"
        type   = "number"
        min    = "0"
        max    = "2147483647"
        step   = "1"
      />
      <input
        v-if     = "field.readonly"
        :class   = "'qa-' +field.name + '__input'"
        :value   = "value"
        ref      = "input"
        type     = "number"
        min      = "0"
        max      = "2147483647"
        step     = "1"
        readonly = "readonly"
        disabled = "disabled"
      />
    </template>
    <template v-if="template === 'detail'">
      <label :class="labelClass ? labelClass : 'u-label'">
        {{ field.label + (field.required ? '* ' : '') }}
      </label>
        <p
          class  = "u-paragraph"
          :class = "'qa-' + field.name + '__value'"
        >
          {{ formattedNumber(value) }}
        </p>
    </template>
  </div>
</template>

<script>
import $ from 'jquery'
import util from '@/functions'

export default {
  props: ['field', 'value', 'labelClass', 'template'],
  methods: {
    update (target) {
      // using valueAsNumber might clear the input in IE on invalid values
      let value = $(target)[0].value
      this.$emit('input', value)
    },
    formattedNumber (value) {
      return util.formatNumber(value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldInteger.vue?c9335982